<template lang="">
    <div>
       <!-- Insert js into Site -->
       <div >
         <!--v-if="pickedLanguage === 'de_DE'"  -->
        <captchaScriptDe />
      </div>
      <!-- Render captcha div -->
        <div class="form-group">
        <div class="mtcaptcha" id="login-captcha"/>
        </div>
    </div>
</template>
<script>

import captchaScriptDe from '../store/captchaScript.js'
export default {

components: {
    captchaScriptDe
},

computed: {
    pickedLanguage: {
      get() { return this.$store.state.pickedLanguage }
    }
},

mounted() {
  // console.log('captchaMounted')
  this.updateLang(this.pickedLanguage)
  this.renderCaptchaOnload()
},

methods: {
    renderCaptchaOnload() {
      window.mtcaptchaConfig.renderQueue.push('login-captcha')
    },

    updateLang(lang) {
      let setLang = lang.slice(0, 2)
      window.mtcaptchaConfig.lang = setLang
    }
},
    
}
</script>
<style lang="">
    
</style>